import type { RowVariantDefinition } from '@/deskUiSkeletons/rowTemplates/RowTemplateTypes'
import { defineRowVariantRegistry } from '@/deskUiSkeletons/rowTemplates/RowVariantRegistry'
import { sharedChatAnswerVariant } from '@/msgComponents/rowVariants/Chat/Chat'
import { productRowVariantForPath, productRowVariantsForPath } from '../../../productDisplayCatalog'
import { MailboxHotmailTemplate } from './variants/MailboxHotmail'

const mailboxHotmailVariant = {
  ...productRowVariantForPath('mailbox', 1),
  Template: MailboxHotmailTemplate,
} as const satisfies RowVariantDefinition

const productRows = productRowVariantsForPath('mailbox')

export const rowVariantRegistry = defineRowVariantRegistry({
  answers: {
    variants: [mailboxHotmailVariant, sharedChatAnswerVariant],
    fallback: productRows.answers.fallback,
  },
  submsges: {
    variants: [mailboxHotmailVariant],
    fallback: productRows.submsges.fallback,
  },
})
